import React, { useEffect, useMemo, useState } from "react"
import { IntlProvider } from "react-intl"
import { Context } from "./Context"
import localEN from "../intl/en.json"
import localDE from "../intl/de.json"
import { AnalyticsRangeProvider } from "./AnalyticsRangeContext"

const messages = {
  de: localDE,
  en: localEN
}

const normalizeLanguage = value => {
  return value && value.toLowerCase().startsWith("de") ? "de" : "en"
}

const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("en")

  useEffect(() => {
    const storedLang = window.localStorage.getItem("lang")
    const browserLang = window.navigator?.language
    setLang(normalizeLanguage(storedLang || browserLang))
  }, [])

  const setLanguage = nextLang => {
    const normalizedLang = normalizeLanguage(nextLang)
    setLang(normalizedLang)
    window.localStorage.setItem("lang", normalizedLang)
  }

  const value = useMemo(
    () => ({
      lang,
      setLanguage,
      toggleLanguage: () => setLanguage(lang === "de" ? "en" : "de"),
      switchToGerman: () => setLanguage("de"),
      switchToEnglish: () => setLanguage("en")
    }),
    [lang]
  )

  return (
    <Context.Provider value={value}>
      <IntlProvider
        locale={lang}
        messages={messages[lang]}
        defaultLocale="en"
        onError={() => {}}
      >
        <AnalyticsRangeProvider>{children}</AnalyticsRangeProvider>
      </IntlProvider>
    </Context.Provider>
  )
}

export default LangProvider
